import Button from "@mui/material/Button";
import React from "react";

export default function TabButton({tabKey, activeTab, label, setActiveTab}) {
  return (
    <Button
      size="small"
      style={{
        color: tabKey === activeTab ? '#fff' : '#111',
        background: tabKey === activeTab ? '#111' : '#fff',
        borderColor: '#111'
      }}
      key={tabKey}
      onClick={(e) => {
        setActiveTab(tabKey)
      }}>
      {label}
    </Button>
  )
}

